import { useState, useEffect } from 'react';

export default function Dashboard() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const statsCards = [
    { label: '在线无人机', value: '24', unit: '架', icon: 'ri-flight-takeoff-line', color: 'teal' },
    { label: '今日飞行架次', value: '156', unit: '次', icon: 'ri-plane-line', color: 'blue' },
    { label: '今日巡检里程', value: '1,847', unit: 'km', icon: 'ri-map-pin-line', color: 'green' },
    { label: '预警事件', value: '3', unit: '个', icon: 'ri-alert-line', color: 'red' }
  ];

  const recentTasks = [
    { id: 1, name: '堆场A区盘点', drone: 'UAV-001', status: '进行中', progress: 75, time: '10:30' },
    { id: 2, name: '3号泊位靠泊辅助', drone: 'UAV-008', status: '进行中', progress: 45, time: '10:45' },
    { id: 3, name: '航道巡检', drone: 'UAV-015', status: '已完成', progress: 100, time: '09:20' },
    { id: 4, name: '环境监测', drone: 'UAV-022', status: '已完成', progress: 100, time: '08:50' },
    { id: 5, name: '安防巡逻', drone: 'UAV-012', status: '待执行', progress: 0, time: '11:00' }
  ];

  const alerts = [
    { id: 1, type: '安全预警', content: '堆场B区检测到明火烟雾', level: 'high', time: '10:52' },
    { id: 2, type: '设备异常', content: '岸桥3号发现结构裂纹', level: 'medium', time: '10:35' },
    { id: 3, type: '环境监测', content: '粉尘浓度超标', level: 'low', time: '10:20' }
  ];

  const droneStatus = [
    { id: 'UAV-001', name: '无人机001', status: '飞行中', battery: 85, location: '堆场A区' },
    { id: 'UAV-008', name: '无人机008', status: '飞行中', battery: 72, location: '3号泊位' },
    { id: 'UAV-015', name: '无人机015', status: '充电中', battery: 45, location: '机库' },
    { id: 'UAV-022', name: '无人机022', status: '待命', battery: 100, location: '机库' },
    { id: 'UAV-012', name: '无人机012', status: '待命', battery: 98, location: '机库' },
    { id: 'UAV-019', name: '无人机019', status: '维护中', battery: 0, location: '维修区' }
  ];

  return (
    <div className="space-y-6">
      {/* 页面标题 */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-white mb-2">实时动态总览</h1>
          <p className="text-gray-400 text-sm">智慧港航无人机平台运营数据</p>
        </div>
        <div className="text-right">
          <div className="text-2xl font-bold text-teal-400">
            {currentTime.toLocaleTimeString('zh-CN')}
          </div>
          <div className="text-sm text-gray-400">
            {currentTime.toLocaleDateString('zh-CN', { year: 'numeric', month: 'long', day: 'numeric' })}
          </div>
        </div>
      </div>

      {/* 统计卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statsCards.map((card, index) => (
          <div
            key={index}
            className="bg-gray-900 border border-teal-500/20 rounded-xl p-6 hover:border-teal-500/40 transition-all"
          >
            <div className="flex items-start justify-between mb-4">
              <div className={`w-12 h-12 bg-${card.color}-500/20 rounded-lg flex items-center justify-center`}>
                <i className={`${card.icon} text-2xl text-${card.color}-400`}></i>
              </div>
              <span className="text-xs text-gray-500">实时</span>
            </div>
            <div className="flex items-baseline gap-2 mb-1">
              <span className="text-3xl font-bold text-white">{card.value}</span>
              <span className="text-sm text-gray-400">{card.unit}</span>
            </div>
            <div className="text-sm text-gray-500">{card.label}</div>
          </div>
        ))}
      </div>

      {/* 主要内容区 */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* 今日任务列表 */}
        <div className="lg:col-span-2 bg-gray-900 border border-teal-500/20 rounded-xl p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold text-white flex items-center gap-2">
              <i className="ri-task-line text-teal-400"></i>
              今日任务列表
            </h2>
            <button className="text-sm text-teal-400 hover:text-teal-300 transition-colors cursor-pointer">
              查看全部 <i className="ri-arrow-right-line"></i>
            </button>
          </div>
          <div className="space-y-3">
            {recentTasks.map((task) => (
              <div
                key={task.id}
                className="bg-gray-800/50 rounded-lg p-4 hover:bg-gray-800 transition-all"
              >
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-teal-500/20 rounded-lg flex items-center justify-center">
                      <i className="ri-flight-takeoff-line text-teal-400"></i>
                    </div>
                    <div>
                      <div className="text-white font-medium">{task.name}</div>
                      <div className="text-xs text-gray-500">{task.drone} · {task.time}</div>
                    </div>
                  </div>
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-medium ${
                      task.status === '进行中'
                        ? 'bg-blue-500/20 text-blue-400'
                        : task.status === '已完成'
                        ? 'bg-green-500/20 text-green-400'
                        : 'bg-gray-500/20 text-gray-400'
                    }`}
                  >
                    {task.status}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="flex-1 h-2 bg-gray-700 rounded-full overflow-hidden">
                    <div
                      className={`h-full rounded-full transition-all ${
                        task.status === '已完成' ? 'bg-green-500' : 'bg-teal-500'
                      }`}
                      style={{ width: `${task.progress}%` }}
                    ></div>
                  </div>
                  <span className="text-xs text-gray-400 w-12 text-right">{task.progress}%</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 预警事件 */}
        <div className="bg-gray-900 border border-teal-500/20 rounded-xl p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold text-white flex items-center gap-2">
              <i className="ri-alert-line text-red-400"></i>
              预警事件
            </h2>
            <span className="w-6 h-6 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
              {alerts.length}
            </span>
          </div>
          <div className="space-y-3">
            {alerts.map((alert) => (
              <div
                key={alert.id}
                className={`border-l-4 rounded-lg p-4 ${
                  alert.level === 'high'
                    ? 'bg-red-500/10 border-red-500'
                    : alert.level === 'medium'
                    ? 'bg-yellow-500/10 border-yellow-500'
                    : 'bg-blue-500/10 border-blue-500'
                }`}
              >
                <div className="flex items-start justify-between mb-2">
                  <span
                    className={`text-xs font-medium ${
                      alert.level === 'high'
                        ? 'text-red-400'
                        : alert.level === 'medium'
                        ? 'text-yellow-400'
                        : 'text-blue-400'
                    }`}
                  >
                    {alert.type}
                  </span>
                  <span className="text-xs text-gray-500">{alert.time}</span>
                </div>
                <p className="text-sm text-white mb-2">{alert.content}</p>
                <button className="text-xs text-teal-400 hover:text-teal-300 transition-colors cursor-pointer">
                  查看详情 <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 无人机状态 */}
      <div className="bg-gray-900 border border-teal-500/20 rounded-xl p-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold text-white flex items-center gap-2">
            <i className="ri-flight-takeoff-line text-teal-400"></i>
            无人机实时状态
          </h2>
          <div className="flex items-center gap-4 text-sm">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span className="text-gray-400">飞行中</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span className="text-gray-400">充电中</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-gray-500 rounded-full"></div>
              <span className="text-gray-400">待命</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
              <span className="text-gray-400">维护中</span>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {droneStatus.map((drone) => (
            <div
              key={drone.id}
              className="bg-gray-800/50 rounded-lg p-4 hover:bg-gray-800 transition-all"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-teal-500/20 rounded-lg flex items-center justify-center">
                    <i className="ri-flight-takeoff-line text-teal-400"></i>
                  </div>
                  <div>
                    <div className="text-white font-medium text-sm">{drone.name}</div>
                    <div className="text-xs text-gray-500">{drone.id}</div>
                  </div>
                </div>
                <div
                  className={`w-2 h-2 rounded-full ${
                    drone.status === '飞行中'
                      ? 'bg-green-500'
                      : drone.status === '充电中'
                      ? 'bg-blue-500'
                      : drone.status === '维护中'
                      ? 'bg-yellow-500'
                      : 'bg-gray-500'
                  }`}
                ></div>
              </div>
              <div className="space-y-2">
                <div className="flex items-center justify-between text-xs">
                  <span className="text-gray-400">状态</span>
                  <span className="text-white">{drone.status}</span>
                </div>
                <div className="flex items-center justify-between text-xs">
                  <span className="text-gray-400">位置</span>
                  <span className="text-white">{drone.location}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-battery-2-charge-line text-gray-400 text-sm"></i>
                  <div className="flex-1 h-2 bg-gray-700 rounded-full overflow-hidden">
                    <div
                      className={`h-full rounded-full ${
                        drone.battery > 60
                          ? 'bg-green-500'
                          : drone.battery > 30
                          ? 'bg-yellow-500'
                          : 'bg-red-500'
                      }`}
                      style={{ width: `${drone.battery}%` }}
                    ></div>
                  </div>
                  <span className="text-xs text-gray-400 w-10 text-right">{drone.battery}%</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}